import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appIntegerOnly]',
  standalone: false,
})
export class IntegerOnlyDirective {
  private regex = /^[0-9]*$/;

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const invalidKeys = ['e', 'E', '+', '-', '.'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text/plain') ?? '';
    if (!this.regex.test(pastedInput)) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event']) onDrop(event: DragEvent) {
    const textData = event.dataTransfer?.getData('text') ?? '';
    if (!this.regex.test(textData)) {
      event.preventDefault();
    }
  }
}
